import React from 'react';
import CountUp from 'react-countup';
import ReactApexChart from 'react-apexcharts';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { cardOptions } from './data';

const AssociateStatusCards = React.memo(({ associateCount }) => {
  const [widgetsData, setWidgetsData] = React.useState([]);

  React.useEffect(() => {
    setWidgetsData([
      {
        id: 1,
        title: 'Clocked In Employees',
        count: associateCount.associatesTimeInToday,
        statusColor: 'warning',
        series: generateRandomNumbers(15, 1, 100),
      },
      {
        id: 2,
        title: 'Assign Employees',
        count: associateCount.assignedAssociates,
        statusColor: 'primary',
        series: generateRandomNumbers(15, 1, 100),
      },
      {
        id: 3,
        title: 'Active Employees',
        count: associateCount.activeAssociates,
        statusColor: 'success',
        series: generateRandomNumbers(15, 1, 100),
      },
      {
        id: 4,
        title: 'Inactive Employees',
        count: associateCount.inactiveAssociates,
        statusColor: 'danger',
        series: generateRandomNumbers(15, 1, 100),
      },
    ]);
  }, [associateCount]);

  const generateRandomNumbers = (length, min, max) =>
    Array.from(
      { length },
      () => Math.floor(Math.random() * (max - min + 1)) + min
    );

  return (
    <Row className="mb-2">
      {widgetsData.map((widget, key) => (
        <Col xl={3} md={6} key={key} className="mb-4">
          <Card className="card-h-100 rounded-2">
            <CardBody>
              <Row className="align-items-center">
                <Col lg={6} md={6} sm={6}>
                  <span className="text-muted mb-2 d-block text-truncate adjust-fs">
                    {widget.title}
                  </span>
                  <h4 className="mb-3">
                    <span
                      className={
                        'counter-value badge bg-' +
                        widget.statusColor +
                        '-subtle text-' +
                        widget.statusColor
                      }
                    >
                      <CountUp
                        start={0}
                        end={widget.count}
                        duration={2}
                        separator=""
                      />
                    </span>
                  </h4>
                </Col>
                <Col lg={6} md={6} sm={6}>
                  <ReactApexChart
                    options={cardOptions}
                    series={[{ data: [...widget.series] }]}
                    type="line"
                    className="apex-charts mb-2"
                    dir="ltr"
                    height={50}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
});

export default AssociateStatusCards;
